import { formatDollars, formatNumber } from '@wix/da-shared-react/pkg/utils/formatting';

export interface Fee {
  flat: string;
  relative: string;
}

/**
 * Formats a fee object into a display string.
 * Handles optional flat fee and percentage, returning empty string if fee is missing or invalid.
 *
 * @param fee - Fee object with flat (in cents) and relative (in basis points) properties
 * @returns Formatted string like "$2.25 + 0.25%", "$2.25", "0.25%", or empty string
 */
export const formatFeeString = (fee: Fee | null | undefined): string => {
  if (!fee) {
    return '';
  }

  const parts: string[] = [];

  if (fee.flat && parseFloat(fee.flat) > 0) {
    const flatInDollars = parseFloat(fee.flat) / 100;
    parts.push(formatDollars(flatInDollars));
  }

  if (fee.relative && parseFloat(fee.relative) > 0) {
    const percentage = formatNumber(parseFloat(fee.relative) / 100, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    parts.push(`${percentage}%`);
  }

  if (parts.length === 0) {
    return '';
  }

  return parts.join(' + ');
};
